import type { ReactNode } from 'react';

type Props = {
  readonly title?: ReactNode;
  readonly meta?: ReactNode;
  readonly children: ReactNode;
};

export function SectionCard({ title, meta, children }: Props) {
  return (
    <section className="section-card">
      {title !== undefined && (
        <h3>
          <span>{title}</span>
          {meta && <span className="count">{meta}</span>}
        </h3>
      )}
      {children}
    </section>
  );
}
